import { MessageResponse } from '../api';

export const MessageType = MessageResponse.TypeEnum;
